import cn from "classnames";

import "./Link.css";

export const Link = ({ children, className, ...props }) => (
  <a className={cn("link", className)} {...props}>
    {children}
  </a>
);
